export default __webpack_public_path__ + "347639ec49f4b2884a9657afded83ace.woff";